/**
 * Purpose: Selection-driven action bar for bulk edits in any dashboard list.
 *          Docks to the bottom on mobile (thumb reach) and sits inline on
 *          desktop. Renders nothing when the selection is empty.
 * Inputs: count (selected), onClear, actions (node — the caller supplies the
 *         buttons, so this component stays free of domain actions), itemLabel
 *         (singular noun, e.g. 'product').
 * Outputs: sticky bar announcing the selection count to screen readers.
 */
import React from 'react';

const BulkActionBar = ({ count = 0, onClear, actions = null, itemLabel = 'item' }) => {
  if (!count) return null;

  const noun = count === 1 ? itemLabel : `${itemLabel}s`;

  return (
    <div
      role="region"
      aria-label="Bulk actions"
      className="sticky bottom-16 z-30 flex flex-wrap items-center gap-3 rounded-2xl border border-gray-200 bg-white p-3 shadow-lg dark:border-gray-700 dark:bg-gray-900 lg:bottom-4"
    >
      <p aria-live="polite" className="text-sm font-semibold text-gray-900 dark:text-gray-100">
        {count} {noun} selected
      </p>
      <div className="scrollbar-hide ml-auto flex items-center gap-2 overflow-x-auto">
        {actions}
        <button
          type="button"
          onClick={onClear}
          className="rounded px-2 py-1 text-xs font-semibold text-gray-500 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:text-gray-400 dark:hover:text-gray-200"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default BulkActionBar;
